import { CenteredModal, LargeModal } from 'components';
import { useApp, useTag } from 'hooks';
import { Pencil, Plus, Trash2 } from 'lucide-react'
import React, { useCallback, useEffect, useState } from 'react'
import TagForm from './TagForm';
import { EProjectActions } from 'types';

export default function Tags() {
    const { trans, onUpdateParams, dataTags, projectDetail } = useApp();
    const projectId = projectDetail?.id;
    const [isFetch, setIsFetch] = useState(1)
    const [item, setItem] = useState(null)
    const [actions, setActions] = useState('')
    const [dataTables, setDataTables] = useState([])
    const { fetchData, updateTag, createTag, delTag } = useTag();
    const [currentTagPage] = useState(1);

    const { data } = fetchData(projectId, currentTagPage, isFetch)

    useEffect(() => {
        if (projectId) setIsFetch(s => ++s)
    }, [projectId]);

    useEffect(() => {
        setDataTables(dataTags ?? []);
    }, [JSON.stringify(dataTags ?? '')]);

    useEffect(() => {
        onUpdateParams({ dataTags: data?.data ?? [] })
    }, [JSON.stringify(data ?? '')]);

    const onClose = (isf = false) => {
        setActions('');
        setItem(null);
        isf && setIsFetch(s => ++s)
    }

    const handleSubmit = (formData) => {
        formData = formData ? { ...formData, project_id: projectId } : { project_id: projectId }
        switch (actions) {
            case 'edit':
                updateTag.mutate(formData, {
                    onSuccess: () => {
                        onClose(true);
                    }
                })
                break;
            case 'add':
                createTag.mutate(formData, {
                    onSuccess: () => {
                        onClose(true);
                    }
                })
                break;
            case 'delete':
                delTag.mutate({ ...formData, id: item.id }, {
                    onSuccess: () => {
                        onClose(true);
                    }
                })
                break;
            default:
                break;
        }
    }

    const renderModalAddUpdate = useCallback(() => (['edit', 'add'].includes(actions)) ? (
        <LargeModal title={`${trans(actions)} thẻ`} onClose={onClose} >
            <TagForm onClose={onClose} onConfirm={handleSubmit} item={item} />
        </LargeModal>) : <></>, [actions, item]);

    return (
        <div>
            <div className="flex justify-end mb-2">
                {projectDetail?.status === EProjectActions.IN_PROGRESS && <button onClick={() => setActions('add')} className=" bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600 transition-colors text-sm">
                    <div className="justify-center flex items-center">
                        <Plus className="w-4 h-4 mr-1" />
                        <span>Thêm</span>
                    </div>
                </button>}
            </div>
            {!!dataTables.length && <div className="overflow-x-auto bg-white shadow">
                <table className="min-w-full table-auto">
                    <thead className="bg-gray-100 text-gray-700 text-sm">
                        <tr>
                            <th className="p-3 text-left">Tên thẻ</th>
                            <th className="p-3 text-left">Màu sắc</th>
                            <th className="p-3 text-center">Tác vụ</th>
                        </tr>
                    </thead>
                    <tbody className="text-sm text-gray-600">
                        {dataTables.map((tag) => (
                            <tr key={tag.id} className="border-t hover:bg-gray-50 border-gray-200">
                                <td className="p-3 flex items-center gap-3">
                                    {tag.name}
                                </td>
                                <td className="p-3">
                                    <span className={`px-2 py-1 text-xs bg-[${tag.color}] text-black `}>
                                        <span className={`px-2 h-4 inline-block mr-2 rounded-full`} style={{ backgroundColor: `${tag.color}` }}>
                                            {tag.color}

                                        </span>
                                    </span>
                                </td>
                                <td className="p-3 flex justify-center gap-2 text-gray-500">
                                    <Pencil onClick={() => { setItem(tag); setActions('edit') }} className="w-4 h-4 cursor-pointer hover:text-blue-600" />
                                    <Trash2 onClick={() => { setItem(tag); setActions('delete') }} className="w-4 h-4 cursor-pointer hover:text-red-600" />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>}
            {projectDetail?.status === EProjectActions.IN_PROGRESS && renderModalAddUpdate()}
            {(['delete'].includes(actions)) && <CenteredModal type={actions} title='Xoá thẻ' description='Bạn có chắc muốn xoá thẻ này không?' onClose={onClose} onConfirm={() => handleSubmit({})} />}
        </div>
    )
}
